// src/lib/recentlyViewed.js
// Tracks recently viewed product handles in localStorage, most recent first.
// Device-level, not tied to a customer account, so guests get this too.

const STORAGE_KEY = 'maisondoud_recently_viewed';
const MAX_ENTRIES = 8;

function readHandles() {
    try {
        const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

// Record a product view — moves the handle to the front if already present.
export function recordView(handle) {
    if (!handle) return;
    const handles = readHandles().filter(h => h !== handle);
    handles.unshift(handle);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ENTRIES)));
}

// Get recently viewed handles, most recent first, optionally excluding one (the current product).
export function getRecentHandles(excludeHandle) {
    return readHandles().filter(h => h !== excludeHandle);
}
